import React, { useEffect, useMemo, useState } from "react"
// import "../Transactions/salesinvoice.scss"
import axios from "../../axios"
import moment from "moment"
import numeral from "numeral"

import toastr from "toastr"
import "toastr/build/toastr.min.css";
import SweetAlert from "react-bootstrap-sweetalert"
import Select from "react-select"
import { makeStyles } from "@material-ui/core/styles"
import Spinner from "react-spinkit"
import Backdrop from "@material-ui/core/Backdrop"
// import Breadcrumbs from "../../components/Common/Breadcrumb"
// import DeleteModal from "../../components/Common/DeleteModal"
// import TableRows from "../../components/Common/TableRows"
// import TableContainer from "../../components/Common/TableContainer"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { saveAs } from "file-saver"
import Switch from "react-switch"
import {
    Divider, Tooltip, TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow, Table,
    TableBody,
    TextField, InputAdornment
} from "@material-ui/core"
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Button as CustomButton2 } from "@mui/material"
import { styled } from "@mui/system"
import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    CardTitle,
    ModalHeader,
    ModalBody,
    Form,
    Card,
    Input,
    Container,
    // Table,
    FormFeedback,
    Label,
    CardBody,
    Button,
    ModalFooter,
} from "reactstrap"
import { set } from "lodash"
const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    dialogpaper: {
        width: "1200px",
    },
}))



const CustomButton = styled(Button)({
    boxShadow: 0,
    marginLeft: 5,
    backgroundColor: "#3468C0",
    color: "#yourCustomTextColor",
    "&:hover": {
        backgroundColor: "#2c3e50",
    },
})

function VendorAccess({
    ShowModalProps,
    EditIdPropsPri,
    EditUomType,
    EditIdPropsSec,
    isEditProps,
    ComponentProps,
    ShowModal,
    Callback



}) {
    const [modal, setModal] = useState(false)

    const [Active, setActive] = useState(true)

    const [deletemsg, setdeletemsg] = useState(false)

    const [Description, setDescription] = useState("")

    const [tokent, settokent] = useState(
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
    )
    const [Uomdata, setUomdata] = useState([])
    // const [Uomdata, setUomdata] = useState([])
    const history = useHistory()
    const [deleteModal, setDeleteModal] = useState(false)
    const [deletid, setdeletid] = useState("")
    const [deletepopup, setdeletepopup] = useState(false)
    const [dailoa1, setdailoa1] = useState(false)
    const classes = useStyles()

    const [edit, setedit] = useState(false)
    const [brandid, setbrandid] = useState("")
    //err
    const [Symbolerr, setSymbolerr] = useState(false)
    const [formalNameerr, setformalNameerr] = useState(false)
    const [UQCerr, setUQCerr] = useState(false)
    const [added, setadded] = useState(false)
    const [duplicateerr, setduplicateerr] = useState(false)

    const [updated, setupdated] = useState(false)

    const [formalname, setformalname] = useState("")
    const [customerAccess, setcustomerAccess] = useState("")
    const [code, setcode] = useState("")

    const [UOMId, setUOMId] = useState("")

    const [Active1, setActive1] = useState(true)
    const options1 = [
        { value: "", text: "Select..." },
        { value: "BAG-BAGS", text: "BAG-BAGS" },
        { value: "BAL-BALE", text: "BAL-BALE" },
        { value: "BDL-BUNDLES", text: "BDL-BUNDLES" },
        { value: "BKL-BUCKLES", text: "BKL-BUCKLES" },
        { value: "BOU-BILLION OF UNITS", text: "BOU-BILLION OF UNITS" },
        { value: "BOX-BOX", text: "BOX-BOX" },
        { value: "BTL-BOTTLES", text: "BTL-BOTTLES" },
        { value: "BUN-BUNCHES", text: "BUN-BUNCHES" },
        { value: "CAN-CANS", text: "CAN-CANS" },
        { value: "CBM-CUBIC METERS", text: "CBM-CUBIC METERS" },
        { value: "CCM-CUBIC CENTIMETERS", text: "CCM-CUBIC CENTIMETERS" },
        { value: "CMS-CENTIMETERS", text: "CMS-CENTIMETERS" },
        { value: "CTN-CARTONS", text: "CTN-CARTONS" },
        { value: "DOZ-DOZENS", text: "DOZ-DOZENS" },
        { value: "DRM-DRUMS", text: "DRM-DRUMS" },
        { value: "GGK-GREAT GROSS", text: "GGK-GREAT GROSS" },
        { value: "GMS-GRAMMES", text: "GMS-GRAMMES" },
        { value: "GRS-GROSS", text: "GRS-GROSS" },
        { value: "GYD-GROSS YARDS", text: "GYD-GROSS YARDS" },
        { value: "KGS-KILOGRAMS", text: "KGS-KILOGRAMS" },
        { value: "KLR-KILOLITRE", text: "KLR-KILOLITRE" },
        { value: "KME-KILOMETER", text: "KME-KILOMETER" },
        { value: "LTR-LITRES", text: "LTR-LITRES" },
        { value: "MLT-MILILITRE", text: "MLT-MILILITRE" },
        { value: "MTR-METERS", text: "MTR-METERS" },
        { value: "MTS-METRIC TON", text: "MTS-METRIC TON" },
        { value: "NOS-NUMBERS", text: "NOS-NUMBERS" },
        { value: "PACK-PACKS", text: "PACK-PACKS" },
        { value: "PCS-PIECES", text: "PCS-PIECES" },
        { value: "PRS-PAIRS", text: "PRS-PAIRS" },
        { value: "QTL-QUNITAL", text: "QTL-QUNITAL" },
        { value: "ROLL-ROLLS", text: "ROLL-ROLLS" },
        { value: "SET-SETS", text: "SET-SETS" },
        { value: "SQF-SQUARE FEET", text: "SQF-SQUARE FEET" },
        { value: "SQM-SQUARE METERS", text: "SQM-SQUARE METERS" },
        { value: "SQY-SQUARE YARDS", text: "SQY-SQUARE YARDS" },
        { value: "TBS-TABLETS", text: "TBS-TABLETS" },
        { value: "TGM-TEN GROSS", text: "TGM-TEN GROSS" },
        { value: "THD-THOUSANDS", text: "THD-THOUSANDS" },
        { value: "TON-TONNES", text: "TON-TONNES" },
        { value: "TUB-TUBES", text: "TUB-TUBES" },
        { value: "UGS-US GALLONS", text: "UGS-US GALLONS" },
        { value: "UNT-UNITS", text: "UNT-UNITS" },
        { value: "YDS-YARDS", text: "YDS-YARDS" },
        { value: "OTH-OTHERS", text: "OTH-OTHERS" },

        // {value: 'Other', text: 'Other'}
    ]

    const [UQC, setUQC] = useState(options1[0].value)

    const [AllCompanyData, setAllCompanyData] = useState([])
    const [tomsAccess, settomsAccess] = useState(false)
    const [imageAccess, setimageAccess] = useState(false)

    const pages = [
        5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
        600, 700, 800, 900, 1000,
    ];
    const [page, setpage] = useState(0);
    const [rowsperpage, setrowsperpage] = useState(pages[page]);

    const [deletedconfirm, setdeletedconfirm] = useState(false);

    const [companyvalue, setcompanyvalue] = useState({
        label: "All Customer",
        value: 0,
    })
    const [editflag, seteditflag] = useState(false)

    const [companyerr, setcompanyerr] = useState(false)

    const handleChangePage = (event, newPage) => {
        setpage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setrowsperpage(parseInt(event.target.value, 10));
        // setpage(0);
    };

    const changepage = () => {
        return Uomdata.slice(
            page * rowsperpage,
            (page + 1) * rowsperpage,
        );
    };

    // useEffect(() => {
    //   GetAllUom1()
    // }, [])

    const toggle = () => {
        if (modal) {
            if (ComponentProps) {
                handleOnCloseToggle(true)
            }
            setActive(true)
            setModal(false)
            setcompanyvalue({ label: "Select Customer", value: 0 })
            setcustomerAccess("")
            setimageAccess(false)
            settomsAccess(false)
            // setUQC(options1[0].value)
        } else {
            setModal(true)

        }
    }


    const [noRecords, setnoRecords] = useState(false)

    useEffect(() => {
        GetAllUom1(Active1)
        GetAllCompany()
    }, [Active1, ShowModal])


    const handleOnClose = (value, Edit) => {
        Callback(value, Edit);
    };
    const handleOnCloseToggle = (value) => {
        Callback(value, '');


    };

    const GetAllCompany = async () => {
        const get = await axios.instance
            .get(`/GetAllcompany`, {
                headers: { Authorization: tokent, "Content-Type": "application/json" },
            })
            .then(res => {
                const data = res.data
                const options = data.map(b => ({
                    label: b.Company_Name,
                    value: b.Company_Id,
                }))
                // options.push({ label: "All Compant", value: 0 })
                setAllCompanyData(options)
            })
    }

    const GetOneVendorHelp = async (id) => {
        const get = await axios.instance
            .get(`/GetOneVendordata/${id}`, {
                headers: { Authorization: tokent, "Content-Type": "application/json" },
            })
            .then(res => {
                if (res.data.length > 0) {
                    for (const data of res.data) {
                        setActive1(data.enable_tompg === "N" ? false : true)
                        setcustomerAccess(data.no_of_Customer_Acc)
                        seteditflag(true)
                        settomsAccess(data.tomsWinAccess === "Y" ? true : false)
                        setimageAccess(data.ImageAccess === "Y" ? true : false)
                    }


                } else {
                    setActive1(false)
                    setcustomerAccess("")

                }
            })

    }




    useEffect(() => {
        //console.log(ShowModal,'Callback',ShowModalProps,'ShowModalProps',isEditProps,'EditUomType',EditUomType)
        if (ComponentProps) {
            if (isEditProps) {
                if (EditUomType == 'Pri') {
                    editquotationProps()
                } else if (EditUomType == 'Sec') {
                    editquotationProps()
                }
            }
            if (ShowModalProps) {
                setModal(ShowModalProps)

            }
        }

    }, [ShowModal])


    const GetAllUom1 = async id => {
        setdailoa1(true)
        const get = await axios.instance
            .get(`/GetAllVendordata/`, {
                headers: { Authorization: tokent, "Content-Type": "application/json" },
            })
            .then(res => {
                const data = res.data
                if (data.length > 0) {
                    setUomdata(res.data)
                } else {
                    setActive1(true)
                    setnoRecords(true)
                }
            })
        setTimeout(() => {
            setdailoa1(false)
        }, 1000)
    }




    const editquotationProps = async () => {
        const get = await axios.instance
            .get(`/Getoneuom/${EditUomType == 'Pri' ? EditIdPropsPri : EditIdPropsSec}`, {
                headers: { Authorization: tokent, "Content-Type": "application/json" },
            })
            .then(res => {
                //console.log(res.data,'uomdata')
                toggle()
                setedit(true)
                const col = res.data
                for (const col of res.data) {
                    setUOMId(col.UOM_Id)
                    setcode(col.UOM_Code)
                    setcustomerAccess(col.UOM_Description)
                    setformalname(col.FORMALNAME)
                    setActive(col.ACTIVE === "N" ? false : true)
                    setUQC(col.UQC)
                }



            })
    }

    const editquotation = async (col) => {
        toggle()



        setedit(true)
        // Getonebrand(col.Brand_Id)
        setUOMId(col.uom_id)

        setcode(col.uom_code)
        setcustomerAccess(col.uom_description)
        setformalname(col.formalname)
        setActive(col.active === "N" ? false : true)
        setUQC(col.uqc)
    }
    const toggledeletemodal = id => {
        setDeleteModal(true)
        setdeletid(id)
    }

    const Deletequotation = async () => {
        const get1 = await axios.instance
            .delete(
                `/DeleteVendorAccessdata/${deletid}`,

                {
                    headers: {
                        Authorization: tokent,
                        "Content-Type": "application/json",
                    },
                }
            )
            .then(res => {
                const data = res.data
                // for(const i of data){
                // setid(i.Brand_Id)
                if (data.length === 1) {
                    setDeleteModal(false)
                    setdeletepopup(true)
                    GetAllUom1(Active1)
                } else {
                    setDeleteModal(false)
                    setdeletemsg(true)
                }
                // }
            })
    }

    // const Getonebrand = async(id) => {
    //     const get= await axios.instance.get(`/Getonebrandfilter1/${id}`,{ headers: {'Authorization':tokent,
    //     'Content-Type': 'application/json',

    //     }}).then((res) => {
    //         for(const data of res.data){
    //             setDescription(data.Brand)
    //             setActive(data.Active==='Y'?true:false)
    //         }
    //     })

    // }

    const columns = useMemo(
        () => [
            {
                Header: "UOM Code",
                accessor: "uom_code",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "UOM Description",
                accessor: "uom_description",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Formal Name",
                accessor: "formalname",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "UQC ",
                accessor: "uqc",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Action",
                accessor: "action",
                disableFilters: true,
                Cell: cellProps => {
                    return (
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            {/* edit icon */}
                            <Tooltip title="Edit" placement="left-start">
                                <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                        const po = cellProps.row.original
                                        editquotation(po)
                                    }}
                                >
                                    <i
                                        className="uil uil-pen font-size-18"
                                        id="edittooltip"
                                        style={{ color: "blue" }}
                                    />
                                </Link>
                            </Tooltip>

                            {/* delete icon */}
                            <Tooltip title="Delete" placement="right-end">
                                <Link
                                    to="#"
                                    className="text-danger"
                                    onClick={() => {
                                        if (
                                            JSON.parse(sessionStorage.getItem("MenuItemUOMControls")).Del ==
                                            "Y"
                                        ) {
                                            const po = cellProps.row.original
                                            toggledeletemodal(po.uom_id)
                                        } else {
                                            toastr.warning(
                                                "Please Contact Admin",
                                                "Operation Not Allowed"
                                            )
                                        }
                                    }}
                                >
                                    <i
                                        className="uil uil-trash-alt font-size-18"
                                        id="deletetooltip"
                                    />
                                </Link>
                            </Tooltip>
                        </div>
                    )
                },
            },
        ],
        []
    )

    const InsertVendorAccess = async () => {
        if (editflag === false) {
            if (companyvalue.value.length != 0) {
                const get1 = await axios.instance
                    .post(
                        `/SaveVendorAccessSpec`,
                        {
                            // UOM_Id: 0,
                            // UOM_Code: 0,
                            // UOM_Description: customerAccess,
                            // Created_By: 1,
                            // Created_Date: moment(new Date()).format("YYYY-MM-DD"),
                            // Modify_By: 0,
                            // Modify_Date: moment(new Date()).format("YYYY-MM-DD"),
                            // formalName: formalname,
                            // UQC: UQC,
                            // Active: Active === true ? "Y" : "N",
                            // Optype: "new",
                            "optype": "new",

                            "company_id": companyvalue.value,
                            "enable_tompg": Active ? "Y" : "N",
                            "no_of_po_acc": 100,
                            "no_of_branch_acc": 100,
                            "no_of_inv_acc": 100,
                            "no_of_approve_acc": 100,
                            "createdby": sessionStorage.getItem('Userid'),
                            "createddate": new Date(),
                            "modifyby": 0,
                            "modifydate": new Date(),
                            "no_of_Customer_Acc": customerAccess,
                            "tomsWinAccess": tomsAccess ? "Y" : "N",
                            "ImageAccess": imageAccess ? "Y" : "N",
                        },
                        {
                            headers: {
                                Authorization: tokent,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then(res => {
                        // if (res.data.length === 1) {
                        setcompanyvalue({ label: "Select Customer", value: 0 })
                        setcustomerAccess("")
                        // setActive(true)

                        toggle()
                        if (ComponentProps) {
                            handleOnClose(true, EditUomType)
                        }
                        setadded(true)
                        GetAllUom1(Active1)
                        // } 
                        // else {
                        //     setduplicateerr(true)
                        // }
                    })
            } else {
                if (companyvalue.value.length === 0) {
                    setcompanyerr(true)
                }

                setTimeout(() => {
                    setcompanyerr(false)
                }, 2000)
            }
        } else {
            if (companyvalue.value.length != 0) {
                const get1 = await axios.instance
                    .post(
                        `/SaveVendorAccessSpec`,
                        {
                            // UOM_Id: 0,
                            // UOM_Code: 0,
                            // UOM_Description: customerAccess,
                            // Created_By: 1,
                            // Created_Date: moment(new Date()).format("YYYY-MM-DD"),
                            // Modify_By: 0,
                            // Modify_Date: moment(new Date()).format("YYYY-MM-DD"),
                            // formalName: formalname,
                            // UQC: UQC,
                            // Active: Active === true ? "Y" : "N",
                            // Optype: "new",
                            "optype": "Edit",

                            "company_id": companyvalue.value,
                            "enable_tompg": Active ? "Y" : "N",
                            "no_of_po_acc": 100,
                            "no_of_branch_acc": 100,
                            "no_of_inv_acc": 100,
                            "no_of_approve_acc": 100,
                            "createdby": sessionStorage.getItem('Userid'),
                            "createddate": new Date(),
                            "modifyby": sessionStorage.getItem('Userid'),
                            "modifydate": new Date(),
                            "no_of_Customer_Acc": customerAccess,
                            "tomsWinAccess": tomsAccess ? "Y" : "N",
                            "ImageAccess": imageAccess ? "Y" : "N",
                        },
                        {
                            headers: {
                                Authorization: tokent,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then(res => {
                        // if (res.data.length === 1) {
                        // setcode("")
                        setcompanyvalue({ label: "Select Customer", value: 0 })
                        setcustomerAccess("")
                        // setformalname("")
                        // setUQC(options1[0].value)
                        // if (ComponentProps) {
                        //     handleOnClose(true, EditUomType)
                        // }

                        toggle()

                        setupdated(true)
                        // GetAllUom1(Active1)
                        seteditflag(false)
                        setedit(false)
                        // } else {
                        //     setduplicateerr(true)
                        // }
                    })
            } else {
                if (companyvalue.value.length === 0) {
                    setcompanyerr(true)
                }

                setTimeout(() => {
                    setcompanyerr(false)
                }, 2000)
            }
        }
    }

    return (
        <React.Fragment>
            {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => Deletequotation()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}

            <div className="page-content" style={{ backgroundColor: "inherit" }}>
                <div className="">
                    <div className="mt-2"></div>
                    {(!ComponentProps) &&
                        <Row>
                            <Col xs="12">
                                <h6 className="titleviewinspections">Vendor Access </h6>
                                <Card>
                                    <CardBody>
                                        <div>
                                            {/* <Breadcrumbs
                      title="Inventory"
                      breadcrumbItem="UOM Master"
                    /> */}
                                        </div>
                                        <Divider sx={{ mb: 2 }} />
                                        <div className="d-flex justify-content-end align-items-center mt-3">
                                            <Col
                                                xl={12}
                                                className="d-flex justify-content-end gap-2 align-items-center"
                                            >
                                                <div
                                                    className="d-flex d-flex-column gap-2 justify-content-end align-items-center pr-2"
                                                    style={{
                                                        borderRight: "1px solid #61677A",
                                                        paddingRight: "10px",
                                                    }}
                                                >
                                                    {/* <h5 className="font-size-14 mt-1">Active UOM</h5>
                                                    <div className="mt-2 ml-2">
                                                        <Switch
                                                            onChange={checked => {
                                                                {
                                                                    checked ? setActive1(true) : setActive1(false)
                                                                }
                                                                GetAllUom1(checked)
                                                            }}
                                                            checked={Active1}
                                                            width={40}
                                                            height={20}
                                                        />
                                                    </div> */}
                                                </div>
                                                <CustomButton
                                                    variant="contained"
                                                    onClick={() => {
                                                        // if (
                                                        //   JSON.parse(sessionStorage.getItem("MenuItemUOMControls"))
                                                        //     .New == "Y"
                                                        // ) {
                                                        toggle()
                                                        // } else {
                                                        //   toastr.warning(
                                                        //     "Please Contact Admin",
                                                        //     "Operation Not Allowed"
                                                        //   )
                                                        // }
                                                    }}
                                                    size="small"
                                                >
                                                    Add Access
                                                </CustomButton>
                                            </Col>
                                        </div>

                                        {/* <TableContainer
                    columns={columns}
                    data={Uomdata}
                    isGlobalFilter={true}
                    isAddOrder={true}
                    isAddTableWithoutBorderStrap={true}
                  /> */}

                                        <div>
                                            {/* <Card className="">
                        <CardBody> */}
                                            <div className="Tabelinspections">
                                                <TableContainer>
                                                    <Table className="InspectionTbls">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Company Name </TableCell>
                                                                <TableCell align="left">Tompg</TableCell>
                                                                <TableCell align="left">User Name</TableCell>
                                                                <TableCell align="left">Customer_Access</TableCell>
                                                                {/* <TableCell>Edit</TableCell> */}
                                                                <TableCell>Delete</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Uomdata.length != 0 ? (
                                                                changepage().map((data, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell style={{ textAlign: "left" }}>
                                                                            {data.Company_Name}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "left" }}>
                                                                            {data.enable_tompg}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "left" }}>
                                                                            {data.User_Name}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "left" }}>
                                                                            {data.no_of_Customer_Acc}
                                                                        </TableCell>

                                                                        {/* <TableCell align="left">
                                                                            <IconButton size="small">                                                                               
                                                                                <EditIcon
                                                                                    fontSize="small"
                                                                                    color="primary"
                                                                                    onClick={() => {
                                                                                     
                                                                                        console.log(data);

                                                                                        editquotation(data)
                                                                                    }}
                                                                                />
                                                                            </IconButton>
                                                                        </TableCell> */}
                                                                        <TableCell align="left">
                                                                            <IconButton size="small">
                                                                                <DeleteIcon
                                                                                    color="error"
                                                                                    fontSize="small"
                                                                                    onClick={() => {
                                                                                        console.log(data, 'deletid');
                                                                                        // setdeletedconfirm(true);
                                                                                        // setdeleteid(data.Termsid);
                                                                                        setdeletedconfirm(true);
                                                                                        // toggledeletemodal(data.branch_id)
                                                                                        setdeletid(data.companyaccessid)
                                                                                    }}
                                                                                />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))
                                                            ) : (
                                                                <TableCell align="left">NO Data Found</TableCell>
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                                <TablePagination
                                                    component="div"
                                                    rowsPerPageOptions={pages}
                                                    count={Uomdata.length}
                                                    rowsPerPage={rowsperpage}
                                                    page={page}
                                                    onChangePage={handleChangePage}
                                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                                />
                                            </div>
                                            {/* <Backdrop open={open}>
                            <Spinner name="ball-spin-fade-loader" color="#fafafa" />
                            <p style={{ marginTop: '50px' }}></p>
                          </Backdrop> */}
                                            {/* </CardBody>
                      </Card> */}

                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>}
                    <Modal isOpen={modal} toggle={toggle} size="lg">
                        <ModalHeader
                            toggle={() => {
                                toggle()
                                setedit(false)
                                setcode("")
                                setcustomerAccess("")
                                setformalname("")
                                setUQC(options1[0].value)
                            }}
                            tag="h4"
                        >
                            {edit === true ? "Edit Vendor Access" : "Add Vendor Access"}
                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                {/* <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Code</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={code}
                      disabled
                      onChange={e => {
                        setcode(e.target.value)
                      }}
                    />
                  </div>
                </Col> */}
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label htmlFor="manufacturerbrand">
                                            <b> Company Name </b>
                                        </Label>
                                        <Select
                                            options={AllCompanyData}
                                            classNamePrefix="select2-search-disable"
                                            value={companyvalue}
                                            onChange={value => {
                                                setcompanyvalue(value)
                                                GetOneVendorHelp(value.value)
                                            }}
                                        />
                                        {
                                            companyerr ? (
                                                <p style={{ color: "red", fontSize: "12px" }}>
                                                    Please Select Company
                                                </p>
                                            ) : null
                                        }
                                    </div>
                                </Col>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label for="basicpill-firstname-input1">
                                            Customer Access
                                        </Label>
                                        <Input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control"
                                            id="basicpill-firstname-input1"
                                            name="Product_Details_Description"
                                            value={customerAccess}
                                            maxLength={50}
                                            onChange={e => {
                                                setcustomerAccess(e.target.value)
                                            }}
                                        />
                                        {Symbolerr == true ? (
                                            <p style={{ color: "red", fontSize: "12px" }}>
                                                Please Enter UOM Description
                                            </p>
                                        ) : null}
                                    </div>
                                </Col>
                                {/* <Col lg="6">
                                    <div className="mb-3">
                                        <Label for="basicpill-firstname-input1">
                                            Formal Name <b className="text-danger">*</b>
                                        </Label>
                                        <Input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control"
                                            id="basicpill-firstname-input1"
                                            name="Product_Details_Description"
                                            value={formalname}
                                            maxLength={50}
                                            onChange={e => {
                                                setformalname(e.target.value)
                                            }}
                                        />
                                        {formalNameerr == true ? (
                                            <p style={{ color: "red", fontSize: "12px" }}>
                                                Please Enter FormalName
                                            </p>
                                        ) : null}
                                    </div>
                                </Col>
                                <Col lg="6" className="mb-2">
                                    <div>
                                        <div>
                                            <label className="input">
                                                UQC <b className="text-danger">*</b>
                                            </label>
                                        </div>
                                        <div>
                                            <select
                                                style={{
                                                    height: "38px",
                                                    cursor: "pointer",
                                                    borderColor: "lightgray",
                                                    marginTop: "5px",
                                                    width: "100%", // Ensure it takes full width of Col
                                                }}
                                                className="input__field"
                                                value={UQC}
                                                onChange={(e) => setUQC(e.target.value)}
                                            >
                                                {options1.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.text}
                                                    </option>
                                                ))}
                                            </select>
                                            {UQCerr && (
                                                <p style={{ color: "red", fontSize: "12px" }}>Please Select UQC</p>
                                            )}
                                        </div>
                                    </div>
                                </Col> */}

                                <Col xl={4}>
                                    <div className="mt-2 d-flex d-flex-row justify-content-start align-items-center gap-2 mb-1 ml-2  ">
                                        <h5 className="font-size-14 mt-1 mr-2">TomPG</h5>
                                        <Switch
                                            onChange={checked => {
                                                {
                                                    checked ? setActive(true) : setActive(false)
                                                }
                                            }}
                                            checked={Active}
                                            width={40}
                                            height={20}
                                        />
                                    </div>
                                </Col>

                                <Col xl={4}>
                                    <div className="mt-2 d-flex d-flex-row justify-content-start align-items-center gap-2 mb-1 ml-2  ">
                                        <h5 className="font-size-14 mt-1 mr-2">Toms Access</h5>
                                        <Switch
                                            disabled={imageAccess}
                                            onChange={checked => {
                                                {
                                                    checked ? settomsAccess(true) : settomsAccess(false)
                                                }
                                            }}
                                            checked={tomsAccess}
                                            width={40}
                                            height={20}

                                        />
                                    </div>
                                </Col>

                                <Col xl={4}>
                                    <div className="mt-2 d-flex d-flex-row justify-content-start align-items-center gap-2 mb-1 ml-2  ">
                                        <h5 className="font-size-14 mt-1 mr-2">Image Access</h5>
                                        <Switch
                                            disabled={tomsAccess}
                                            onChange={checked => {
                                                {
                                                    checked ? setimageAccess(true) : setimageAccess(false)
                                                }
                                            }}
                                            checked={imageAccess}
                                            width={40}
                                            height={20}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <ModalFooter>
                                {edit === false ? (
                                    <CustomButton2
                                        variant="contained"
                                        color="info"
                                        size="small"
                                        onClick={() => {
                                            InsertVendorAccess()
                                        }}
                                        style={{
                                            backgroundColor: "#1746A2",
                                            color: "white",
                                            border: 0,
                                            textTransform: "capitalize",
                                        }}
                                    >
                                        Save
                                    </CustomButton2>
                                ) : (
                                    <CustomButton2
                                        style={{
                                            backgroundColor: "#1746A2",
                                            color: "white",
                                            border: 0,
                                            textTransform: "capitalize",
                                        }}
                                        size="small"
                                        variant="contained"
                                        color="info"
                                        onClick={() => {
                                            // if (
                                            //   JSON.parse(sessionStorage.getItem("MenuItemUOMControls"))
                                            //     .Edit == "Y"
                                            // ) {
                                            InsertVendorAccess()
                                            // } else {
                                            //   toastr.warning(
                                            //     "Please Contact Admin",
                                            //     "Operation Not Allowed"
                                            //   )
                                            // }
                                        }}
                                    >
                                        Update
                                    </CustomButton2>
                                )}
                            </ModalFooter>
                        </ModalBody>
                    </Modal>
                </div>
            </div>

            <Backdrop open={dailoa1} className={classes.backdrop}>
                <Spinner name="ball-spin-fade-loader" color="#fafafa" />
            </Backdrop>

            {deletepopup ? (
                <SweetAlert
                    title="Vendor Access Deleted Successfully"
                    timeout={2000}
                    style={{
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    success
                    onConfirm={() => {
                        setdeletepopup(false)
                    }}
                ></SweetAlert>
            ) : null}

            {deletemsg ? (
                <SweetAlert
                    title="Transaction Found Can't Be Delete This Record"
                    timeout={2000}
                    style={{
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setdeletemsg(false)
                    }}
                ></SweetAlert>
            ) : null}

            {added ? (
                <SweetAlert
                    title="Vendor Access Added Successfully"
                    timeout={2000}
                    style={{
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    success
                    onConfirm={() => {
                        setadded(false)
                    }}
                ></SweetAlert>
            ) : null}

            {updated ? (
                <SweetAlert
                    title="Vendor Access Updated Successfully"
                    timeout={2000}
                    style={{
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    success
                    onConfirm={() => {
                        setupdated(false)
                    }}
                ></SweetAlert>
            ) : null}

            {noRecords ? (
                <SweetAlert
                    title="No Records Found for InActive"
                    timeout={2000}
                    style={{
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setnoRecords(false)
                    }}
                ></SweetAlert>
            ) : null}

            {duplicateerr ? (
                <SweetAlert
                    title="UOM Already Exist"
                    timeout={2000}
                    style={{
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setduplicateerr(false)
                    }}
                ></SweetAlert>
            ) : null}

            {deletedconfirm ? (
                <SweetAlert
                    title="Are You Sure?"
                    style={{
                        position: 'absolute',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    confirmBtnBsStyle="success"
                    showConfirm={true}
                    cancelBtnBsStyle="danger"
                    cancelBtnText="Cancel"
                    confirmBtnText="Yes,delete it!"
                    showCancel={true}
                    warning
                    onConfirm={() => {
                        Deletequotation();
                        setdeletedconfirm(false);
                    }}
                    onCancel={() => {
                        setdeletedconfirm(false);
                        // setdeleted(false);
                    }}
                >
                    <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
                </SweetAlert>
            ) : null}
        </React.Fragment>
    )
}

export default VendorAccess
